import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"
import img from "../../../assets/images/Wwings.png"
//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./Sidebar"

// Super Admin

import { Link } from "react-router-dom"

const Sidebar = props => {

  const isDevelopment = process.env.NODE_ENV === "development"

  // Define the class name based on the environment
  const className = isDevelopment ? "development" : ""

  // See Sidebar.js — clicking the logo re-opens the sidebar when it's
  // collapsed to icon-only; it never collapses it, only expands.
  const expandSidebarIfCollapsed = () => {
    const body = document.body
    if (body.classList.contains("vertical-collpsed")) {
      body.classList.remove("vertical-collpsed")
      body.classList.remove("sidebar-enable")
    }
  }

  return (
    <React.Fragment>
      <div className={`vertical-menu ${className}`}>
        {/* See Sidebar.js — the brand box now sizes and centers itself in CSS
            ($sidebar-brand-height in _vertical.scss). */}
        <div
          className="navbar-brand-box"
          onClick={expandSidebarIfCollapsed}
        >
          <Link to="" className="logo logo-dark">
            <span className="logo-sm">
              <img src={img} alt="" height="30" />
            </span>
            <span className="logo-lg">
              <img src={img} alt="" height="64" />
            </span>
          </Link>

          <Link to="" className="logo logo-light pb-3">
            <span className="logo-sm">
              <img src={img} alt="" height="30" />
            </span>
            <span className="logo-lg">
              <img src={img} alt="" height="64" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
